import { render, staticRenderFns } from "./bell-fill.vue?vue&type=template&id=145f9502&"
import script from "./bell-fill.vue?vue&type=script&lang=js&"
export * from "./bell-fill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports